import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Etiqueta } from 'src/app/models/ind/etiqueta/etiqueta';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstoqueService extends AbstractIdbaService {

  constructor(http: HttpClient) {
    super(http);
    this.programName = "est/estoque/estoque.p";
  }

  listarEstoqueAtivo(registro) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "est/estoque/estoque.p";
    request.procedure = 'pi-lista-estoque-etiquetas';
    request.parameters = { ...registro };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  listarEstoqueProduto(rowid: string) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "est/estoque/estoque.p";
    request.procedure = 'pi-lista-estoque-produto';
    request.parameters = { rowid };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  listarEstoqueOnline() {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-lista-estoque-online';
    request.parameters = {};
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  desativarEtiqueta(etiqueta: Etiqueta) {
    var request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "ind/producao/apontamento.p";
    request.procedure = 'pi-estorna-etiqueta';
    request.parameters = { codigoEtiqueta: etiqueta.numeroEtiqueta };
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }
}
